import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ClassGroupVpaPointsCard @event={{@model}}/>",{ moduleName: "bullitt-time-results/templates/event/vpa/points.hbs" })